export default __webpack_public_path__ + "static/media/bodnar_balazs.24e24df4.jpeg";